import { useLocation, Link } from 'react-router-dom'
import { useEffect } from 'react'
import { Button } from '@/components/ui/button'

const NotFound = () => {
  const location = useLocation()

  useEffect(() => {
    console.error(
      '404 Error: User attempted to access non-existent route:',
      location.pathname,
    )
  }, [location.pathname])

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black text-white p-4">
      <div className="text-center space-y-6">
        <h1 className="text-8xl font-black font-heading text-primary text-glow">
          404
        </h1>
        <h2 className="text-3xl font-bold">Página não encontrada</h2>
        <p className="text-xl text-gray-400 max-w-md mx-auto">
          Parece que você se perdeu do caminho para a elite.
        </p>
        <Button
          asChild
          className="bg-primary hover:bg-primary/90 text-white font-bold px-8 py-6 rounded-lg"
        >
          <Link to="/">Voltar para o Início</Link>
        </Button>
      </div>
    </div>
  )
}

export default NotFound
